export default __webpack_public_path__ + "static/media/project1_shop.ce5938de.gif";